import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';
import { breakpoint } from '../../../../styles/dontgiftguide.styles';

const { fonts } = dggTheme;

const singleSnowflakeURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt3f6424008a571182/single-snowflake-light.png';

const socksURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt786152aca24261df/6526f58eb8038a804130ccc1/sock-graphic.png';

const mugsURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/blt5395e09548fdf398/6526f5929d1a1cb656b38106/mug-graphic.png';

const bottleURL =
  'https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltaed982ba065e0b82/6526f594fbc4f6006f9aec6c/bottle-graphic.png';

const sidePadding = 180;

export const root = css`
  h4 {
    font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    font-size: ${pxToRem(22)};

    ${mediaQuery(
      { min: breakpoint },
      css`
        width: ${pxToRem(300)};
        margin-bottom: ${pxToRem(12)};
        font-size: ${pxToRem(48)};
        line-height: ${pxToRem(48)};
      `,
    )}
  }

  p {
    padding-bottom: ${pxToRem(20)};
    line-height: 1.3;

    ${mediaQuery(
      { min: breakpoint },
      css`
        width: ${pxToRem(500)};
        font-size: ${pxToRem(20)};
      `,
    )}
  }
`;

export const socksPaddingTop = 20;
export const socksImageHeight = { mobile: 200, default: 350 };

export const socks = css`
  position: relative;
  margin: 0 auto;
  padding-left: ${pxToRem(10)};
  padding-top: ${pxToRem(socksPaddingTop)};
  background-image: url(${socksURL});
  background-repeat: no-repeat;
  background-position: right ${pxToRem(40)};
  background-size: auto ${socksImageHeight.mobile}px;
  min-height: ${socksImageHeight.mobile}px;
  color: #fff;
  text-align: left;

  p {
    padding-right: ${pxToRem(sidePadding)};
  }

  &:after {
    position: absolute;
    display: block;
    top: ${socksImageHeight.mobile + 10}px;
    left: calc(90%);
    margin: 0;
    width: 40px;
    height: 40px;
    content: '';

    background-image: url(${singleSnowflakeURL});
    background-size: contain;
    background-repeat: no-repeat;

    ${mediaQuery(
      { min: breakpoint },
      css`
        top: ${socksImageHeight.default - 30}px;
        left: calc(86%);
        margin: 0;
        width: 70px;
        height: 70px;
      `,
    )}
  }

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(680)};
      background-position: right ${pxToRem(40)} top ${pxToRem(40)};
      background-size: auto ${pxToRem(socksImageHeight.default)};
      min-height: ${pxToRem(400)};
    `,
  )}
`;

export const mugs = css`
  position: relative;
  margin: 0 auto;
  padding-right: ${pxToRem(10)};
  background-image: url(${mugsURL});
  background-repeat: no-repeat;
  background-position: center left;
  background-size: 150px;
  color: #fff;
  text-align: right;

  &:before {
    position: absolute;
    display: block;
    top: 2%;
    left: 12%;
    margin: 0;
    width: 40px;
    height: 40px;
    content: '';

    background-image: url(${singleSnowflakeURL});
    background-size: contain;
    background-repeat: no-repeat;

    ${mediaQuery(
      { min: breakpoint },
      css`
        top: 2%;
        left: 16%;
        margin: 0;
        width: 70px;
        height: 70px;
      `,
    )}
  }

  p {
    padding-left: ${pxToRem(sidePadding)};
  }

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(680)};
      background-position: top ${pxToRem(80)} left;
      background-size: ${pxToRem(350)};
      min-height: ${pxToRem(400)};

      h4,
      p,
      a {
        float: right;
      }
    `,
  )}
`;

export const bath = css`
  margin: 0 auto;
  padding-bottom: ${pxToRem(35)};
  padding-left: ${pxToRem(10)};
  background-image: url(${bottleURL});
  background-repeat: no-repeat;
  background-position: top ${pxToRem(16)} right ${pxToRem(20)};
  background-size: ${pxToRem(115)};
  color: #fff;
  text-align: left;

  p {
    padding-right: ${pxToRem(sidePadding)};
  }

  h4 {
    width: ${pxToRem(200)};
  }

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(680)};
      background-position: top right ${pxToRem(40)};
      margin-top: ${pxToRem(60)};
      background-size: ${pxToRem(220)};
      min-height: ${pxToRem(450)};

      h4 {
        padding-top: ${pxToRem(40)};
      }
    `,
  )}
`;
